var _rect, _path, _path2, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2702_39221)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2702_39221)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2702_39221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 20,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 20,
    height: 15,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2702_39221)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5V16.5H23V1.5H3Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2702_39221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 20,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5V16.5H23V1.5H3Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2702_39221)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2702_39221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 20,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 20,
    height: 15,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2702_39221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.773438 15.4285L5.17449 17.2898L23.1003 3.52378L25.4217 0.757856L20.7154 0.135759L13.4039 6.06793L7.51893 10.0648L0.773438 15.4285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.375 16.7326L3.61713 17.8127L24.5872 0.500906H21.4389L1.375 16.7326Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2266 15.4285L20.8255 17.2898L2.89973 3.52378L0.578276 0.757856L5.28457 0.135759L12.5961 6.06793L18.4811 10.0648L25.2266 15.4285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0762 16.3644L22.834 17.4446L13.9048 10.0325L11.2575 9.20435L0.354679 0.767349H3.5029L14.3995 9.00409L17.2939 9.99711L25.0762 16.3644Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_2702_39221",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3615 0.25H10.6393V6.5H1.76758V11.5H10.6393V17.75H15.3615V11.5H24.2676V6.5H15.3615V0.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3615 0.25H10.6393V6.5H1.76758V11.5H10.6393V17.75H15.3615V11.5H24.2676V6.5H15.3615V0.25Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6393 0.25V-1H9.38926V0.25H10.6393ZM15.3615 0.25H16.6115V-1H15.3615V0.25ZM10.6393 6.5V7.75H11.8893V6.5H10.6393ZM1.76758 6.5V5.25H0.517578V6.5H1.76758ZM1.76758 11.5H0.517578V12.75H1.76758V11.5ZM10.6393 11.5H11.8893V10.25H10.6393V11.5ZM10.6393 17.75H9.38926V19H10.6393V17.75ZM15.3615 17.75V19H16.6115V17.75H15.3615ZM15.3615 11.5V10.25H14.1115V11.5H15.3615ZM24.2676 11.5V12.75H25.5176V11.5H24.2676ZM24.2676 6.5H25.5176V5.25H24.2676V6.5ZM15.3615 6.5H14.1115V7.75H15.3615V6.5ZM10.6393 1.5H15.3615V-1H10.6393V1.5ZM11.8893 6.5V0.25H9.38926V6.5H11.8893ZM1.76758 7.75H10.6393V5.25H1.76758V7.75ZM3.01758 11.5V6.5H0.517578V11.5H3.01758ZM10.6393 10.25H1.76758V12.75H10.6393V10.25ZM11.8893 17.75V11.5H9.38926V17.75H11.8893ZM15.3615 16.5H10.6393V19H15.3615V16.5ZM14.1115 11.5V17.75H16.6115V11.5H14.1115ZM24.2676 10.25H15.3615V12.75H24.2676V10.25ZM23.0176 6.5V11.5H25.5176V6.5H23.0176ZM15.3615 7.75H24.2676V5.25H15.3615V7.75ZM14.1115 0.25V6.5H16.6115V0.25H14.1115Z",
    fill: "white",
    mask: "url(#path-11-inside-1_2702_39221)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 20,
    height: 15,
    fill: "url(#paint0_linear_2702_39221)",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2,
    width: 19,
    height: 14,
    rx: 1,
    stroke: "black",
    strokeOpacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2702_39221",
    x: 0,
    y: 0.5,
    width: 26,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2702_39221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2702_39221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2702_39221",
    x1: 13,
    y1: 1.5,
    x2: 13,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2702_39221"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 20,
    height: 15,
    rx: 1.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.71f9c51fd352e31524657c878d0718ca.svg";
export { ForwardRef as ReactComponent };